export default "__VITE_ASSET__Dr1lIWqs__"